import { useMemo, useState } from "react";
import { rankingList } from "@/mocks/ranking";

const sortTabs = ["综合热度", "评分优先", "追番人数"];

function trendMeta(trend: string) {
  if (trend === "up") return { icon: "ri-arrow-up-line", className: "text-primary-600", label: "上升" };
  if (trend === "down") return { icon: "ri-arrow-down-line", className: "text-foreground-500", label: "下降" };
  if (trend === "new") return { icon: "ri-fire-line", className: "text-accent-600", label: "新入榜" };
  return { icon: "ri-subtract-line", className: "text-foreground-500", label: "持平" };
}

function parseFollowers(value: string) {
  return parseFloat(value.replace("万", ""));
}

export default function Ranking() {
  const [sortBy, setSortBy] = useState("综合热度");

  const list = useMemo(() => {
    const copy = [...rankingList];
    if (sortBy === "评分优先") return copy.sort((a, b) => b.score - a.score);
    if (sortBy === "追番人数") return copy.sort((a, b) => parseFollowers(b.followers) - parseFollowers(a.followers));
    return copy.sort((a, b) => a.rank - b.rank);
  }, [sortBy]);

  return (
    <section id="ranking" className="bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="text-sm font-medium text-primary-600">追番人气榜</span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">本季追番人气与评分排行</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              榜单综合追番人数、评分与近期讨论热度生成，可用于挑选人气较高或口碑较稳的作品。切换排序维度会即时重排下面的条目。
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {sortTabs.map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => setSortBy(tab)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  sortBy === tab
                    ? "bg-primary-500 text-background-50"
                    : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {list.map((item, index) => {
            const trend = trendMeta(item.trend);
            return (
              <article
                key={item.id}
                className={`flex items-center gap-3 p-3 transition-colors hover:bg-primary-50 md:gap-4 md:p-4 ${
                  index !== 0 ? "border-t border-background-200" : ""
                }`}
              >
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-base md:h-9 md:w-9 ${
                    item.rank <= 3 ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {item.rank}
                </span>
                <div className="h-16 w-12 shrink-0 overflow-hidden rounded-md md:h-20 md:w-[60px]">
                  <img src={item.cover} alt={`${item.title} 榜单封面`} className="h-full w-full object-cover object-top" />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-medium text-foreground-950 md:text-base">{item.title}</h3>
                  <p className="mt-1 text-xs text-foreground-600">{item.tag}</p>
                  <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-700">
                    <span className="flex items-center gap-1">
                      <i className="ri-user-heart-line"></i>
                      {item.followers}
                    </span>
                    <span className={`flex items-center gap-1 ${trend.className}`}>
                      <i className={trend.icon}></i>
                      {trend.label}
                    </span>
                  </div>
                </div>
                <div className="shrink-0 text-right">
                  <p className="font-heading text-lg text-primary-700 md:text-xl">{item.score}</p>
                  <p className="text-[11px] text-foreground-600">综合评分</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}